import script from "./AdminAttributesPage.vue?vue&type=script&setup=true&lang=js"
export * from "./AdminAttributesPage.vue?vue&type=script&setup=true&lang=js"

import "./AdminAttributesPage.vue?vue&type=style&index=0&id=577a0cca&scoped=true&lang=css"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-577a0cca"]])

export default __exports__